import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Endpoints } from '../../../../../apis';
import { INSTANCE_LIST_QUERY_KEY } from '../../../../../hooks/CloudComputeHooks/useInstanceListQuery';
import { QUOTAS_QUERY_KEY } from '../../../../../hooks/useQuotasQuery';
import { getErrorMessage } from '@xver/utils/error';

export function useLaunchInstanceMutate() {
    const { t } = useTranslation('notifications');
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: Endpoints.v1.Instances.launchInstance,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: INSTANCE_LIST_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: QUOTAS_QUERY_KEY });
            notifications.show({
                title: t('instance.launched'),
                message: t('instance.launchedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
            navigate('/cloud-compute');
        },
        onError: (error: any) => {
            notifications.show({
                title: t('instance.launchFailed'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
